import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "paging-bar" }
const _hoisted_2 = ["onClick"]


export default /*@__PURE__*/_defineComponent({
  __name: 'PagingBar',
  props: ['pagingData'],
  emits: ['goToPage'],
  setup(__props, { emit: __emit }) {

    // eslint-disable-next-line no-unused-vars
    const props = __props
    // eslint-disable-next-line no-unused-vars
    const emits = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.pagingData?.pagesCount>1)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.pagingData?.pagesCount, (numberOfPage, index) => {
          return (_openBlock(), _createElementBlock("button", {
            key: index,
            class: _normalizeClass( { active: index == __props.pagingData.currentPage }),
            onClick: ($event: any) => (_ctx.$emit('goToPage', index))
          }, _toDisplayString(index + 1), 11 /* TEXT, CLASS, PROPS */, _hoisted_2))
        }), 128 /* KEYED_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})